import { connect } from 'react-redux';
import {getTranslation} from "../../../reducers/common/localization";
import {getCurrentGroup, getCurrentGroupName} from "../../../reducers/account/role";
import {
    getBulkConsentRequestsFormattedData, getBulkRequestsJobs,
    loadingBulkConsentRequests, onResumeBulkConsentRequest
} from "../../../reducers/consent/bulkConsentRequests";
import BulkConsentRequestsList from "./BulkConsentRequestsList";
import {hideModal, MODAL_REMOVE_BULK_CONSENT_REQUEST, showModal} from "../../../reducers/common/activeModal";
// import {fetchGetOrgBalance, getConsentRequestFee, getOrgBalance, getPaidTillDate} from "../../../reducers/organization/organization";

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        loading: loadingBulkConsentRequests(state),
        data: getBulkConsentRequestsFormattedData(state),
        groupId: getCurrentGroup(state),
        groupName: getCurrentGroupName(state),
        // balance: getOrgBalance(state),
        // consentRequestFee: getConsentRequestFee(state),
        // paidTillDate: getPaidTillDate(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        // onMount: () => dispatch(fetchGetOrgBalance()),
        onLoadJobs: () => dispatch(getBulkRequestsJobs()),
        onRemoveBulk: () => dispatch(showModal({modalKey: MODAL_REMOVE_BULK_CONSENT_REQUEST})),
        onCancelRemoving: () => dispatch(hideModal()),
        onResumeBulk: (id) => dispatch(onResumeBulkConsentRequest(id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkConsentRequestsList);



// WEBPACK FOOTER //
// ./src/components/consentManagement/bulkConsentRequestsList/BulkConsentRequestsList.container.js